import { useContext } from "react"
import { LoaderContext } from "../context"

export default () => {
  const context = useContext(LoaderContext)
  if (!context) {
    throw new Error('LoaderContext cannot be used outside LoaderContext.Provider')
  }
  return context
}